import { api, API_URL } from './client';

export async function listJobs(filters = {}, options = {}) {
  const params = new URLSearchParams();
  if (filters.status && filters.status !== 'all') {
    params.append('status', filters.status);
  }

  const url = `${API_URL}/api/v1/jobs${params.toString() ? '?' + params : ''}`;
  return api.get(url, options);
}

export async function getJob(jobId, options = {}) {
  return api.get(`${API_URL}/api/v1/jobs/${jobId}`, options);
}

export async function submitJob(jobData, options = {}) {
  const { traceId, ...rest } = jobData;
  return api.post(
    `${API_URL}/api/v1/jobs`,
    {
      idempotency_key: crypto.randomUUID(),
      ...rest,
    },
    { ...options, traceId: options.traceId || traceId }
  );
}

export async function cancelJob(jobId, options = {}) {
  return api.post(`${API_URL}/api/v1/jobs/${jobId}/cancel`, {}, options);
}
